import { Currency } from '@shared/enums';

export function mapLanguageToCurrency(language: string) {
  switch (language) {
    case 'en':
    case 'de':
    case 'fr':
      return Currency.Usd;

    case 'pl':
      return Currency.Pln;

    case 'uk':
    default:
      return Currency.Uah;
  }
}
